import { useMutation } from "@tanstack/react-query";
import Axios from "Services/Auth/AxiosInterceptors";

const bulkUpdateStatesAPI = async (payload) => {
  const response = await Axios.patch("/state-restriction/doctor/bulk-update", payload);
  return response.data;
};

export const useBulkUpdateStates = () => {
  return useMutation({
    mutationFn: bulkUpdateStatesAPI,
  });
};
